import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatologueEntry"
import DataCache from "../../StaticData/StaticDataCache";
import { IGeneralApiClient } from "../../../Common/ApiClients/GeneralApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles"
import StaticCurrencyLookup from '../../../Common/Models/StaticCurrencyLookup';
import { TextConstants } from '../../../Common/TextConstants';

export default class StaticCurrencyCatalogueEntry extends CatalogueEntry<StaticCurrencyLookup> {

    constructor() {
        super("Static Currency", StaticCurrencyLookup);
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.staticCurrencies;
    }
    
    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.saveStaticCurrencyList;
    }
    
    public renderRow(item: StaticCurrencyLookup, meta: Model.TransformMetaType<StaticCurrencyLookup>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.currencySymbol} />
                <NeoGrid.Column bind={meta.currencyCode} />
                <NeoGrid.Column label={TextConstants.Labels.CurrencyCodeAlternativeReference} bind={meta.currencyCodeRef1} />
                <NeoGrid.Column bind={meta.isDeletedInd} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}